import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4.2 5l-.7 1.9L17.6 12H3v8h18v-8.86L4.2 5zM7 17H5v-2h2v2zm12 0H9v-2h10v2z"
}), 'ScannerSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ScannerSharp.js
// module id = 5896
// module chunks = 2